<!-- op: String 'perfil', 'legajo'  -->
<template>
    <div>
        <DialogoFotoIa ref="dialFoto" :picture="fotoafi" />
        <v-card flat class="d-flex flex-column align-center justify-center mb-2">
            <v-card-title style="word-break: break-word;"
                class="font-weight-bold text-body-1 primary--text text--lighten-1">
                {{ label.toUpperCase() }}
            </v-card-title>
            <v-card-text>
                <v-avatar size="180" style="position: relative; border: 1px solid #00a0df;" tile>
                    <!-- :src="`data:image/png;base64,${this.fototmp}`" -->
                    <v-img :src="(fotoafi == '') ? getImage : `data:image/png;base64,${fotoafi}`" contain></v-img>
                    <v-btn v-if="$device.isDesktop" color="primary" class="py-5 px-8" @click="lanzarDialogo"
                        style="position: absolute; top: 78%;  ">
                        <v-icon class="mr-2">mdi-camera-plus-outline</v-icon>agregar foto
                    </v-btn>
                    <!--     <v-btn v-else-if="$device.isMobile" color="primary" class="py-5 px-8" @click="lanzarDialogo"
                        style="position: absolute; top: 78%;  ">
                        <v-icon class="mr-2">mdi-camera-plus-outline</v-icon>agregar foto
                    </v-btn> -->
                    <InputPhoto v-else-if="$device.isMobile" titulo="seleccionar" style="position: absolute; top: 78%;"
                        icono=" mdi-folder-outline" width="300px" @fotoCargada="fotoSeleccionada" :tipo="fotocarnet">
                    </InputPhoto>
                </v-avatar>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>

import InputPhoto from '@/components/inputs/InputPhoto.vue'
import { mapGetters, mapActions } from 'vuex'
import DialogoFotoIa from '@/components/dialogos/DialogoFotoIa.vue'
import imgEmptyLegajo from '@/assets/blank-user-profile.png'
import imgEmptyPerfil from '@/assets/businessman.png'

export default {
    data() {
        return {
            selectedFiles: [],
            imagePreview: null,
            fileSizeError: false,
            loading: false,
            fileSizeErrorMessage: '',
            image: imagePdf,
            fileName: '',

            picture: '',
            fotoafi: ''
        };
    },
    components: {
        InputPhoto,
        DialogoFotoIa,
    },

    computed: {
        ...mapGetters('auth', ['isAuthenticated']),

        habilitarEliminar() {
            return (this.disabled)
        },
        getImage() {
            if (this.fotoafi == '') {
                if (this.op.includes('perfil')) return imgEmptyPerfil
                else if (this.op.includes('legajo')) return imgEmptyLegajo
                else return imgEmptyLegajo
            }
        }
    },
    methods: {
        ...mapActions('dataUser', ['addFiles']),
        ...mapActions('preafiliacion', ['addFilesPre']),


        lanzarDialogo() {
            this.picture =
                this.$refs.dialFoto.abrirDialogo()
        },

        handleFileImport() {
            // Trigger click on the FileInput
            try {
                this.$refs.fileInput.click();
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },
        handleFileUpload(event) {
            /*             const file = event.target.files[0]
                        const tipo = event.target.files[0].type
                        const size = event.target.files[0].size
                        if (file) {
                            this.loading = true
                            if ((tipo == 'image/jpeg' || tipo == 'image/jpg' || tipo == 'image/png') && (size <= 5 * 1024 * 1024)) {
                                this.fileSizeError = false;
                                this.compressAndConvertToPNG(file)
                                    .then(imageUrl => {
                                        this.selectedFiles.push(file);
                                        (this.isAuthenticated) ? this.addFiles({ file: file, op: this.op }) : this.addFilesPre({ file: file, op: this.op })
                                        this.$emit('fileSelected')
                                        this.showImagePreview(imageUrl);
                                    })
                                    .catch(error => {
                                        console.error('Error al procesar la imagen:', error);
                                    }).finally(() => {
                                        this.loading = false
                                    });
            
                            } else if ((tipo == 'application/pdf') && (size <= 5 * 1024 * 1024)) {
                                this.selectedFiles.push(file);
                                (this.isAuthenticated) ? this.addFiles({ file: file, op: this.op }) : this.addFilesPre({ file: file, op: this.op })
                                this.$emit('fileSelected')
                                this.showImagePreview(this.image)
                                this.fileName = file.name
                            } else {
                                this.reduceImageSize(file, 800).then(reducedFile => {
                                    this.compressAndConvertToPNG(reducedFile).then(imageUrl => {
                                        //this.selectedFiles.push(reducedFile);
                                        (this.isAuthenticated) ? this.addFiles({ file: reducedFile, op: this.op }) : this.addFilesPre({ file: reducedFile, op: this.op })
                                        this.$emit('fileSelected');
                                        this.showImagePreview(imageUrl)
                                    })
                                })
                            }
                        } else {
                            this.loading = false
                            console.log('error')
                        } */
        },
        reduceImageSize(file, maxWidth) {
            /* return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        const aspectRatio = img.width / img.height;
                        let newWidth = maxWidth;
                        let newHeight = maxWidth / aspectRatio;
                        if (img.width > maxWidth) {
                            canvas.width = newWidth;
                            canvas.height = newHeight;
                            ctx.drawImage(img, 0, 0, newWidth, newHeight);
                            canvas.toBlob((blob) => {
                                const reducedFile = new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() });
                                resolve(reducedFile);
                            }, 'image/jpeg');
                        } else {
                            resolve(file); // No es necesario reducir el tamaño
                        }
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(file);
            }); */
        },
        compressAndConvertToPNG(file) {
            /*   return new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = (event) => {
                      const img = new Image();
                      img.onload = () => {
                          const canvas = this.$refs.canvas;
                          const ctx = canvas.getContext('2d');
                          canvas.width = img.width;
                          canvas.height = img.height;
                          ctx.drawImage(img, 0, 0);
                          canvas.toBlob((blob) => {
                              const imageUrl = URL.createObjectURL(blob);
                              resolve(imageUrl);
                          }, 'image/png');
                      };
                      img.src = event.target.result;
                  };
                  reader.readAsDataURL(file);
              }); */
        },
        showImagePreview(imageUrl) {
            this.loading = false
            this.imagePreview = imageUrl;
        },
        deleteImage() {
            /*   this.selectedFiles = [];
              (this.isAuthenticated) ? this.addFiles({ file: '', op: this.op }) : this.addFilesPre({ file: '', op: this.op })
              this.$emit('fileSelected')
              this.imagePreview = null;
              this.fileName = '';
              this.$refs.fileInput.value = ''; */ // Limpiar el valor del input file
        },
        fotoSeleccionada() {

        }
    },
    props:
    {
        label: {
            type: String,
            required: false
        },

        //op: 'perfil' o 'legajo'
        op: {
            type: String,
            required: true
        },
        fotoafi: {
            type: String,
            default: '',
            required: false
        }
    },
};
</script>
